/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type AdmissionType = "InPatient" | "Observation" | "OutPatient" | "%future added value";
export type BarrierStatus = "Open" | "Resolved" | "%future added value";
export type BedRequestStatus = "Anticipated" | "AnticipatedDischarge" | "AnticipatedUnitTransfer" | "Cancelled" | "CheckedIn" | "DischargeOrderWithDelay" | "Discharged" | "IntentToAdmit" | "Pending" | "PendingDischarge" | "PendingUnitTransfer" | "Ready" | "ReadyForDischarge" | "ReadyForUnitTransfer" | "Transferred" | "%future added value";
export type BedRequestType = "Admission" | "UnitTransfer" | "%future added value";
export type DepartmentType = "AdmissionSource" | "Unit" | "%future added value";
export type MilestoneStatus = "Completed" | "NA" | "Open" | "Removed" | "%future added value";
export type OwnerMessageStatus = "ACKNOWLEDGED" | "NEEDS_REASSIGNMENT" | "UNACKNOWLEDGED" | "%future added value";
export type ProgressionIndicator = "AtRisk" | "HighRisk" | "NotSet" | "OnTime" | "%future added value";
export type Track = "Discharge" | "Progression" | "%future added value";
export type VisitStatus = "Admitted" | "Discharged" | "PreAdmission" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type EscalationListPaginationContainer_search$ref: FragmentReference;
declare export opaque type EscalationListPaginationContainer_search$fragmentType: EscalationListPaginationContainer_search$ref;
export type EscalationListPaginationContainer_search = {|
  +userSetting?: ?{|
    +barriers: $ReadOnlyArray<{|
      +id: string,
      +name: ?string,
      +description: ?string,
      +active: ?boolean,
      +dischargeDelay: ?boolean,
      +category: ?{|
        +code: ?string,
        +value: ?string,
      |},
      +templateId: ?any,
    |}>
  |},
  +barrierEscalationRoles?: ?$ReadOnlyArray<?{|
    +code: string,
    +value: string,
    +ordinal: number,
    +active: boolean,
  |}>,
  +deliveryMethods: ?$ReadOnlyArray<?{|
    +code: string,
    +active: boolean,
  |}>,
  +viewer: {|
    +beds: {|
      +totalCount: number,
      +pageInfo: {|
        +endCursor: ?string,
        +hasNextPage: boolean,
        +hasPreviousPage: boolean,
        +startCursor: ?string,
        +totalCount: string,
      |},
      +edges: $ReadOnlyArray<{|
        +bed: {|
          +id: string,
          +name: string,
          +exchangeName: string,
          +status: string,
          +department: {|
            +id: string,
            +exchangeName: string,
            +name: string,
            +type: DepartmentType,
          |},
          +visit: ?{|
            +id: string,
            +vector: ?{|
              +id: string,
              +patientId: string,
              +encounterId: string,
              +predictionDate: any,
              +conditions: ?$ReadOnlyArray<?{|
                +name: string,
                +riskBracket: ?string,
                +riskFactors: $ReadOnlyArray<?{|
                  +id: string,
                  +type: string,
                  +description: string,
                |}>,
                +recommendations: $ReadOnlyArray<?{|
                  +id: string,
                  +rank: string,
                  +description: string,
                  +code: string,
                  +accepted: ?boolean,
                |}>,
              |}>,
            |},
            +admissionTime: ?any,
            +admissionType: ?AdmissionType,
            +admittingComplaint: ?string,
            +anticipatedDischargeTime: ?any,
            +anticipatedDischargeUpdatedBy: ?{|
              +id: string,
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
            +attendingPhysician: ?{|
              +firstName: ?string,
              +id: string,
              +lastName: ?string,
            |},
            +bedRequestStatus: ?BedRequestStatus,
            +bedRequests: $ReadOnlyArray<{|
              +id: string,
              +bedRequestType: BedRequestType,
              +bedRequestStatus: BedRequestStatus,
              +updatedWhen: any,
              +bedExchangeName: ?string,
            |}>,
            +currentDayOfStay: ?number,
            +decisionTime: ?any,
            +dischargeVendor: ?string,
            +drgAttributes: ?{|
              +id: string,
              +code: string,
              +level: string,
              +title: string,
            |},
            +drgUpdatedBy: ?{|
              +id: string,
              +firstName: string,
              +lastName: string,
              +userName: string,
            |},
            +homeBedExchangeName: ?string,
            +insurancePlans: $ReadOnlyArray<{|
              +id: string,
              +planName: string,
              +priority: any,
            |}>,
            +meta: {|
              +id: string,
              +decisionDue: boolean,
              +dischargeToday: boolean,
              +plannedDischargeExceeded: boolean,
              +timeElapsedSinceAdmission: any,
              +tlosExceeded: boolean,
            |},
            +patient: {|
              +id: string,
              +age: ?string,
              +firstName: ?string,
              +gender: ?string,
              +lastName: ?string,
              +middleInitial: ?string,
              +mrn: ?string,
            |},
            +patientProblem: ?string,
            +targetDischargeTime: ?any,
            +tlos: ?number,
            +visitNumber: ?string,
            +visitStatus: VisitStatus,
            +workingDischargeDisposition: ?{|
              +code: ?string,
              +id: string,
              +value: ?string,
            |},
            +plan: ?{|
              +id: string,
              +barriers: $ReadOnlyArray<?{|
                +id: string,
                +name: string,
                +description: string,
                +dischargeDelay: ?boolean,
                +pinned: boolean,
                +status: BarrierStatus,
                +category: {|
                  +id: string,
                  +code: string,
                  +value: string,
                  +sourceTypes: ?$ReadOnlyArray<?{|
                    +id: string,
                    +code: string,
                    +value: string,
                    +active: boolean,
                    +activeDirectorySourceName: boolean,
                    +hasConfiguredList: boolean,
                    +sourceDetails: ?$ReadOnlyArray<?{|
                      +id: string,
                      +code: string,
                      +value: string,
                      +active: boolean,
                    |}>,
                  |}>,
                |},
                +escalation: ?{|
                  +id: string,
                  +auditMeta: ?{|
                    +createdBy: {|
                      +id: string,
                      +userName: string,
                      +firstName: string,
                      +lastName: string,
                    |},
                    +updatedBy: {|
                      +id: string,
                      +userName: string,
                      +firstName: string,
                      +lastName: string,
                    |},
                    +created: any,
                    +updated: any,
                  |},
                |},
                +auditMeta: ?{|
                  +createdBy: {|
                    +id: string,
                    +userName: string,
                    +firstName: string,
                    +lastName: string,
                  |},
                  +updatedBy: {|
                    +id: string,
                    +userName: string,
                    +firstName: string,
                    +lastName: string,
                  |},
                  +created: any,
                  +updated: any,
                |},
                +ownerMessageStatus: ?OwnerMessageStatus,
                +ownerMessageStatusDate: ?any,
                +ownerMessageDeliveryDate: ?any,
                +ownerKnownUser?: ?{|
                  +id: string,
                  +emailReceiver: boolean,
                  +instantMessageReceiver: boolean,
                |},
                +owner: ?string,
                +ownerRole: ?{|
                  +id: string,
                  +code: ?string,
                  +value: ?string,
                |},
                +sourceTypeCode: ?string,
                +sourceName: ?string,
                +notes: ?$ReadOnlyArray<?{|
                  +id: string,
                  +text: string,
                  +pinned: boolean,
                  +auditMeta: ?{|
                    +createdBy: {|
                      +id: string,
                      +userName: string,
                      +firstName: string,
                      +lastName: string,
                    |},
                    +updatedBy: {|
                      +id: string,
                      +userName: string,
                      +firstName: string,
                      +lastName: string,
                    |},
                    +created: any,
                    +updated: any,
                  |},
                |}>,
              |}>,
              +careTeamMembers: $ReadOnlyArray<?{|
                +id: string,
                +name: ?string,
                +role: {|
                  +id: string,
                  +code: ?string,
                  +value: ?string,
                |},
                +primary: ?boolean,
              |}>,
              +meta: ?{|
                +milestoneMeta: {|
                  +overdue: any,
                  +onTime: any,
                  +completed: any,
                |},
                +lengthOfStayMeta: {|
                  +forecast: ?any,
                  +cappedForecast: ?any,
                |},
                +actualOE: ?number,
              |},
              +milestones: $ReadOnlyArray<?{|
                +id: string,
                +name: string,
                +description: ?string,
                +dueDate: ?any,
                +dueDateCutoff: boolean,
                +completedDate: ?any,
                +track: ?Track,
                +status: MilestoneStatus,
                +duplicate: boolean,
              |}>,
              +progressionIndicator: ProgressionIndicator,
              +toBeAdmitted: ?boolean,
            |},
            +anticipatedTransferTime: ?any,
            +anticipatedDischargeTimeAutoPopulated: ?boolean,
            +anticipatedTransferTimeAutoPopulated: ?boolean,
          |},
        |}
      |}>,
    |}
  |},
  +$refType: EscalationListPaginationContainer_search$ref,
|};
export type EscalationListPaginationContainer_search$data = EscalationListPaginationContainer_search;
export type EscalationListPaginationContainer_search$key = {
  +$data?: EscalationListPaginationContainer_search$data,
  +$fragmentRefs: EscalationListPaginationContainer_search$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exchangeName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v12 = [
  (v3/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bedRequestStatus",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dischargeDelay",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditMeta",
  "kind": "LinkedField",
  "name": "auditMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditUser",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditUser",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updated",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = [
  (v3/*: any*/),
  (v0/*: any*/),
  (v14/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "getSettingsRoles"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "query"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "skipOwnerKnownUser"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "type"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": [
          "viewer",
          "beds"
        ]
      }
    ]
  },
  "name": "EscalationListPaginationContainer_search",
  "selections": [
    {
      "alias": "deliveryMethods",
      "args": [
        {
          "kind": "Literal",
          "name": "codeTableType",
          "value": "DeliveryMethod"
        }
      ],
      "concreteType": "CodeTable",
      "kind": "LinkedField",
      "name": "codeTables",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": "codeTables(codeTableType:\"DeliveryMethod\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": "beds",
          "args": [
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "query"
            },
            {
              "kind": "Variable",
              "name": "type",
              "variableName": "type"
            }
          ],
          "concreteType": "BedConnection",
          "kind": "LinkedField",
          "name": "__EscalationListPaginationContainer_beds_connection",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                (v2/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BedEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": "bed",
                  "args": null,
                  "concreteType": "Bed",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v4/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Department",
                      "kind": "LinkedField",
                      "name": "department",
                      "plural": false,
                      "selections": [
                        (v3/*: any*/),
                        (v5/*: any*/),
                        (v4/*: any*/),
                        (v7/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Visit",
                      "kind": "LinkedField",
                      "name": "visit",
                      "plural": false,
                      "selections": [
                        (v3/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PatientVector",
                          "kind": "LinkedField",
                          "name": "vector",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "patientId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "encounterId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "predictionDate",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PatientCondition",
                              "kind": "LinkedField",
                              "name": "conditions",
                              "plural": true,
                              "selections": [
                                (v4/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "riskBracket",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "PatientRiskFactor",
                                  "kind": "LinkedField",
                                  "name": "riskFactors",
                                  "plural": true,
                                  "selections": [
                                    (v3/*: any*/),
                                    (v7/*: any*/),
                                    (v8/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "PatientRecommendation",
                                  "kind": "LinkedField",
                                  "name": "recommendations",
                                  "plural": true,
                                  "selections": [
                                    (v3/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "rank",
                                      "storageKey": null
                                    },
                                    (v8/*: any*/),
                                    (v0/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "accepted",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "admissionTime",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "admissionType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "admittingComplaint",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "anticipatedDischargeTime",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AuditUser",
                          "kind": "LinkedField",
                          "name": "anticipatedDischargeUpdatedBy",
                          "plural": false,
                          "selections": (v12/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PersonnelRole",
                          "kind": "LinkedField",
                          "name": "attendingPhysician",
                          "plural": false,
                          "selections": [
                            (v10/*: any*/),
                            (v3/*: any*/),
                            (v11/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v13/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "BedRequest",
                          "kind": "LinkedField",
                          "name": "bedRequests",
                          "plural": true,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "bedRequestType",
                              "storageKey": null
                            },
                            (v13/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "updatedWhen",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "bedExchangeName",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentDayOfStay",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "decisionTime",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "dischargeVendor",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DrgAttributes",
                          "kind": "LinkedField",
                          "name": "drgAttributes",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "level",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "title",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AuditUser",
                          "kind": "LinkedField",
                          "name": "drgUpdatedBy",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v10/*: any*/),
                            (v11/*: any*/),
                            (v9/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "homeBedExchangeName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "InsurancePlan",
                          "kind": "LinkedField",
                          "name": "insurancePlans",
                          "plural": true,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "planName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "priority",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "VisitMeta",
                          "kind": "LinkedField",
                          "name": "meta",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "decisionDue",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "dischargeToday",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "plannedDischargeExceeded",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "timeElapsedSinceAdmission",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "tlosExceeded",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Patient",
                          "kind": "LinkedField",
                          "name": "patient",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "age",
                              "storageKey": null
                            },
                            (v10/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "gender",
                              "storageKey": null
                            },
                            (v11/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "middleInitial",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "mrn",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "patientProblem",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "targetDischargeTime",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tlos",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "visitNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "visitStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkingDischargeDispositionDTO",
                          "kind": "LinkedField",
                          "name": "workingDischargeDisposition",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v3/*: any*/),
                            (v14/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Plan",
                          "kind": "LinkedField",
                          "name": "plan",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Barrier",
                              "kind": "LinkedField",
                              "name": "barriers",
                              "plural": true,
                              "selections": [
                                (v3/*: any*/),
                                (v4/*: any*/),
                                (v8/*: any*/),
                                (v15/*: any*/),
                                (v16/*: any*/),
                                (v6/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "BarrierCategory",
                                  "kind": "LinkedField",
                                  "name": "category",
                                  "plural": false,
                                  "selections": [
                                    (v3/*: any*/),
                                    (v0/*: any*/),
                                    (v14/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "BarrierSourceType",
                                      "kind": "LinkedField",
                                      "name": "sourceTypes",
                                      "plural": true,
                                      "selections": [
                                        (v3/*: any*/),
                                        (v0/*: any*/),
                                        (v14/*: any*/),
                                        (v1/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "activeDirectorySourceName",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "hasConfiguredList",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "BarrierSourceDetail",
                                          "kind": "LinkedField",
                                          "name": "sourceDetails",
                                          "plural": true,
                                          "selections": [
                                            (v3/*: any*/),
                                            (v0/*: any*/),
                                            (v14/*: any*/),
                                            (v1/*: any*/)
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Escalation",
                                  "kind": "LinkedField",
                                  "name": "escalation",
                                  "plural": false,
                                  "selections": [
                                    (v3/*: any*/),
                                    (v17/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v17/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "ownerMessageStatus",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "ownerMessageStatusDate",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "ownerMessageDeliveryDate",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "owner",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "CodeTablePair",
                                  "kind": "LinkedField",
                                  "name": "ownerRole",
                                  "plural": false,
                                  "selections": (v18/*: any*/),
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "sourceTypeCode",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "sourceName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "BarrierNote",
                                  "kind": "LinkedField",
                                  "name": "notes",
                                  "plural": true,
                                  "selections": [
                                    (v3/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "text",
                                      "storageKey": null
                                    },
                                    (v16/*: any*/),
                                    (v17/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "condition": "skipOwnerKnownUser",
                                  "kind": "Condition",
                                  "passingValue": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "KnownUser",
                                      "kind": "LinkedField",
                                      "name": "ownerKnownUser",
                                      "plural": false,
                                      "selections": [
                                        (v3/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "emailReceiver",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "instantMessageReceiver",
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ]
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CareTeamMember",
                              "kind": "LinkedField",
                              "name": "careTeamMembers",
                              "plural": true,
                              "selections": [
                                (v3/*: any*/),
                                (v4/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "CodeTablePair",
                                  "kind": "LinkedField",
                                  "name": "role",
                                  "plural": false,
                                  "selections": (v18/*: any*/),
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "primary",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PlanMeta",
                              "kind": "LinkedField",
                              "name": "meta",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "MilestoneMeta",
                                  "kind": "LinkedField",
                                  "name": "milestoneMeta",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "overdue",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "onTime",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "completed",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "LengthOfStayMeta",
                                  "kind": "LinkedField",
                                  "name": "lengthOfStayMeta",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "forecast",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "cappedForecast",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "actualOE",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Milestone",
                              "kind": "LinkedField",
                              "name": "milestones",
                              "plural": true,
                              "selections": [
                                (v3/*: any*/),
                                (v4/*: any*/),
                                (v8/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "dueDate",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "dueDateCutoff",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "completedDate",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "track",
                                  "storageKey": null
                                },
                                (v6/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "duplicate",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "progressionIndicator",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "toBeAdmitted",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "anticipatedTransferTime",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "anticipatedDischargeTimeAutoPopulated",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "anticipatedTransferTimeAutoPopulated",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Bed",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "getSettingsRoles",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserSetting",
          "kind": "LinkedField",
          "name": "userSetting",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FavoriteBarrier",
              "kind": "LinkedField",
              "name": "barriers",
              "plural": true,
              "selections": [
                (v3/*: any*/),
                (v4/*: any*/),
                (v8/*: any*/),
                (v1/*: any*/),
                (v15/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CodeTablePair",
                  "kind": "LinkedField",
                  "name": "category",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v14/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "templateId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "barrierEscalationRoles",
          "args": [
            {
              "kind": "Literal",
              "name": "codeTableType",
              "value": "BarrierEscalationRole"
            }
          ],
          "concreteType": "CodeTable",
          "kind": "LinkedField",
          "name": "codeTables",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v14/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ordinal",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": "codeTables(codeTableType:\"BarrierEscalationRole\")"
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '1ad1f3428afc6bc393c95304c0d171e8';

module.exports = node;
